module.exports = __webpack_public_path__ + "img/60.10f5da58.jpg";